import React, { useEffect } from 'react';
import {
    Box,
    InputLabel,
    Grid,
    Typography,
    FormGroup,
    FormControlLabel,
    Switch,
    TextField,
    CircularProgress,
    Divider,
    Checkbox
} from '@mui/material';
import { createState, Downgraded, useState } from '@hookstate/core';
import { useParams, useHistory } from 'react-router-dom';
import RouteConstants from '../../constants/routeConstants';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import AppConstants from '../../constants/appConstants';
import { generatePath } from 'react-router-dom';
import {
    FULL_PERMISSION,
    NO_ACCESS_PERMISSION,
    VIEW_PERMISSION,
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import PhoneNumber from '../../sharedcomponents/PhoneNumber/phoneNumber';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import Title from '../../sharedcomponents/title/title';
import MUIDatePicker from '../../sharedcomponents/datePicker';
import dayjs from 'dayjs';
import { updateModuleState, useEventState } from '../../stores/eventStore';

const flightinfo = createState({
    flightoneAmExrecLocatornum: '',
    isfamilyMemberAttend: false,
    familyMemberName: '',
    familyMemberDOB: null,
    familyMemberPhone: '',
    familyMemberRelation: '',
    familyMemberAmExlocatornumber: '',
});

const Createflightinfo = () => {
    const eventState = useEventState();
    const state = useState(flightinfo);
    let params = useParams();
    const history = useHistory();
    // console.log(history);
    const [participantList, setParticipantList] = React.useState(null);
    const [isParticipant, setIsParticipant] = React.useState(true);
    const [showDetails, setShowDetails] = React.useState(false);
    const [participant, setParticipant] = React.useState(null);
    const [NameErr, setNameErr] = React.useState('');
    const [relationerr, setRelationerr] = React.useState('');
    const [DOBErr, setDOBerr] = React.useState('');
    const [phoneerr, setPhoneError] = React.useState('');
    const [armxerror, setarmxerror] = React.useState('');
    const [famarmxerror, setFamarmxerror] = React.useState('');
    const [flightinfoId, setflightinfoId] = React.useState(0);
    const [participantNameErr, setParticipantNameErr] = React.useState('');
    const [partiErrorState, setPartiErrorState] = React.useState(false);
    const [endUserFlightinfo, setEndFlightinfo] = React.useState('');
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [endUserFlightinfoData, setEndUserFlightinfoData] =
        React.useState('');
    const loading = useState(false);
    const [checkEditPermission, setCheckEditPermission] = React.useState(false);
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const agentConnection = Helper.getStorage('agentConnections') ? Helper.getStorage('agentConnections') : Helper.getSessionStorage('agentConnections');
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);
    const [showFamilySection, setShowFamilySection] = React.useState(false);

    useEffect(() => {
        getModuleConfig();
    }, [])

    useEffect(() => {
        if (eventState.get() && eventState.eventDetail.get() != null) {
            if (Helper.isEventAdmin(userInfo) || Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo)) {
                setModPermission(FULL_PERMISSION);
            } else {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(
                            permissions,
                            "FLIGHTINFO"
                        )
                    );
                }
            }
        }
    }, [eventState]);

    useEffect(() => {
        const gEventInfo = Helper.getStorage('eventInfo');
        if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
            (userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            setIsParticipant(true);
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(
                    gEventInfo.eventID
                )
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants);
                    if (params.flightinfoID > 0) {
                        setParticipantList(history.location.state.participantList);
                        const index = participants.findIndex(
                            (user) => user.userID == history.location.state.flightinfoState.userID
                        );
                        if (index > -1) {
                            setParticipant(participants[index]);
                        }
                    } else {
                        const index = participants.findIndex(
                            (user) => user.userID == 0
                        );
                        // console.log("history.location.state",history.location.state);

                        if (index > -1) {
                            setParticipant(participants[index]);
                        }
                        if (history.location.state?.addedUserIds?.length > 0) {
                            const newFilteredParti = participants.filter((user) => !history.location.state.addedUserIds.includes(user.userID))
                            // console.log("newFilteredParti",newFilteredParti);
                            setParticipantList(newFilteredParti)
                        }

                    }
                }
            })
        }
        resetState();
    }, [])

    useEffect(() => {
        if (
            (modPermission && modPermission == FULL_PERMISSION) ||
            modPermission == VIEW_PERMISSION
        ) {
            if (params.flightinfoID) {
                if (history.location.state?.flightinfoState) {
                    const editState = history.location.state.flightinfoState;
                    setflightinfoId(Number(params.flightinfoID));
                    state.set({
                        flightoneAmExrecLocatornum: editState.playerAmExLocatorNo,
                        isfamilyMemberAttend: editState.isfamilyMemberAttend,
                        familyMemberName: editState.familyMemberName,
                        familyMemberDOB: (editState.familyMemberDOB && editState.familyMemberDOB != "" ) ? dayjs(editState.familyMemberDOB).format('YYYY-MM-DDTHH:mm') : "",
                        familyMemberPhone: editState.familyMemebrContactNo,
                        familyMemberRelation: editState.relation,
                        familyMemberAmExlocatornumber: editState.familyAmExLocatorNo,
                    });
                }
            } else {
                resetState()
            }
        }
    }, [modPermission]);

    // useEffect(() => {  
    //     if (!(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo))) {
    //         if (modPermission) {
    //             if (modPermission == FULL_PERMISSION) {
    //                 setCheckEditPermission(true);
    //             } else if (modPermission == VIEW_PERMISSION) {
    //                 setCheckEditPermission(false);
    //             } else {
    //                 setCheckEditPermission(false);
    //             }
    //         }
    //         ApiHelper.get(
    //             APIURLConstants.GET_COMBINE_FLIGHTINFO(
    //                 eventInfo.eventID,
    //                 agentConnection
    //                     ? false
    //                     : userInfo.userType == 'Admin'
    //                     ? true
    //                     : false,
    //                 userInfo.userID
    //             )
    //         )
    //             .then((res) => {
    //                 if (res.data.length !== 0) {
    //                     if (res.data) {                             
    //                         setEndFlightinfo(res?.data[0]?.flightinfoId);
    //                         setEndUserFlightinfoData(res?.data[0]); 
    //                     }
    //                 }
    //             })
    //             .catch((error) => {
    //                 console.log(error);
    //             });
    //     }
    // }, [modPermission]);

    const getModuleConfig = () => {
        const gEventInfo = Helper.getStorage('eventInfo');
        const ModuleID = 26;
        const type = "IsFlightInfoTwo";

        ApiHelper.get(APIURLConstants.GET_MODULE_CONFIG(ModuleID, type))
            .then((res) => {
                // console.log(res.data);
                let data = res.data && res.data.length > 0 ? res.data.find(i => i.eventID === gEventInfo.eventID) : null;
                if (data) {
                    let val = data.value == 1 ? true : false;
                    setShowFamilySection(val);
                    if (!val) {
                        state.isfamilyMemberAttend.set(true);
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };

    const GetflightInfoSettingByUserID = (userID) => {
        const gEventInfo = Helper.getStorage('eventInfo');
        ApiHelper.get(
            APIURLConstants.GET_COMBINEFLIGHTINFO_SETTING_BY_USERID(
                gEventInfo.eventID,
                userID
            )
        ).then((res) => {
            if (res.data.setting) {
                const transportSettingData = JSON.parse(res.data.setting);
                if (transportSettingData) {
                    const finalSettingData = JSON.parse(
                        transportSettingData[0].TransportSetting
                    );
                    if (finalSettingData !== null) {
                        state.set({
                            ...state.get(),
                            flightinfo: finalSettingData.flightinfo,
                        });
                    }
                }
            }
        });
    };



    const resetState = () => {
        state.flightoneAmExrecLocatornum.set(''),
            state.isfamilyMemberAttend.set(false),
            state.familyMemberName.set(''),
            state.familyMemberDOB.set(null),
            state.familyMemberPhone.set(''),
            state.familyMemberRelation.set(''),
            state.familyMemberAmExlocatornumber.set('');
    };



    const handleDisableBtn = () => {
        if (params.flightinfoID > 0) {
            const editflightinfoState = history.location.state.flightinfoState;
            let prevData = {
                flightoneAmExrecLocatornum: editflightinfoState.playerAmExLocatorNo,
                isfamilyMemberAttend: editflightinfoState.isfamilyMemberAttend,
                Name: editflightinfoState.isfamilyMemberAttend,
                DOB: editflightinfoState.familyMemberDOB,
                Contact: editflightinfoState.familyMemebrContactNo,
                Relation: editflightinfoState.relation,
                familyMemberAmExlocatornumber: editflightinfoState.familyAmExLocatorNo,
            }
            let currentData = {
                flightoneAmExrecLocatornum: state.flightoneAmExrecLocatornum.get(),
                isfamilyMemberAttend: state.isfamilyMemberAttend.get(),
                Name: state.familyMemberName.get(),
                DOB: state.familyMemberDOB.get(),
                Contact: state.familyMemberPhone.get(),
                Relation: state.familyMemberRelation.get(),
                familyMemberAmExlocatornumber: state.familyMemberAmExlocatornumber.get(),
            }

            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true)
            } else {
                setDisableBtn(false)
            }
        } else {
            setDisableBtn(false)
        }

    }

    const changeParticipant = (participant) => {
        if (participant) {
            // GetflightInfoSettingByUserID(participant.userID);
            setPartiErrorState(false);
            setParticipantNameErr('');
        } else {
            setPartiErrorState(true);
            setParticipantNameErr('Please Select Participant');
        }
        setParticipant(participant);
        setDisableBtn(false)
    };

    const onChangefamilyMemberAttend = (e) => {
        state.isfamilyMemberAttend.set(e.target.checked);
        if (e.target.checked) {
            setNameErr('');
            setDOBerr('');
            setPhoneError('');
            setRelationerr('')
            setFamarmxerror('')
        } else {
            validateName();
            validateDOB();
            validatePhone(state.familyMemberPhone.get());
            validateRelation(state.relation.get());
            handlefamilyAmExRecordChange(state.familyMemberAmExlocatornumber.get())
        }
        handleDisableBtn();
    };

    const validateName = () => {
        let value = state.familyMemberName.get().trim();
        if (!state.isfamilyMemberAttend.get() && value == '') {
            setNameErr('Please Enter Family Member Contact Name');
            return false;
        }
        else if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(value)) {
            setNameErr('Please enter valid family member contact name');
            return false;
        }
        else {
            setNameErr('');
            return true;
        }
    };
    const validateRelation = () => {
        let value = state.familyMemberRelation.get();
        if (!state.isfamilyMemberAttend.get()) {
            if (value == "") {
                setRelationerr('Please Enter Family Member Relation');
                return false;
            } else if (!Helper.onlyLettersAndSpacesWithHyphens(value) && state.isfamilyMemberAttend.get()) {
                setRelationerr('Please Enter Valid Family Member Relation');
                return false;
            } else {
                setRelationerr('');
                return true;
            }
        }
    };

    const validateDOB = () => {
        let value = state.familyMemberDOB.get();
        if (value == '' || value == null) {
            setDOBerr('Please Enter Family Member Date of Birth');
            return false;
        } else {
            setDOBerr('');
            return true;
        }
    };

    const validatePhone = (val) => {
        let value = val;
        if (value === '') {
            setPhoneError('Please Enter Family Member Phone Number');
            return false;
        } else if (value && !Helper.isValidPhoneNumber(value)) {
            setPhoneError('Please Enter Valid Phone Number');
            return false;
        } else {
            setPhoneError('');
            return true;
        }
    };
    const isValidForm = () => {
        let isValid = true;
        if (((state.flightoneAmExrecLocatornum.get() && state.flightoneAmExrecLocatornum.get().trim()) == '') || armxerror.length > 0) {
            setarmxerror('Please enter AmEx Record Locator Number');
            isValid = false;
        }
        if (!state.isfamilyMemberAttend.get()) {
            if (((state.familyMemberName.get() && state.familyMemberName.get().trim()) == '') || NameErr.length > 0) {
                setNameErr('Please Enter Family Member Contact Name');
                isValid = false;
            }
            if ((state.familyMemberRelation.get() && state.familyMemberRelation.get().trim()) == '' || relationerr.length > 0) {
                setRelationerr('Please Enter Family Member Relation');
                isValid = false;
            }
            if ((state.familyMemberDOB.get() == '' || state.familyMemberDOB.get() == null) || DOBErr.length > 0) {
                setDOBerr('Please Enter Family Member Date of Birth');
                isValid = false;
            }
            if (state.familyMemberPhone.get() === '' || phoneerr.length > 0) {
                setPhoneError('Please Enter Family Member Phone Number');
                isValid = false;
            }
            if (((state.familyMemberAmExlocatornumber.get() && state.familyMemberAmExlocatornumber.get().trim()) == '') || famarmxerror.length > 0) {
                setFamarmxerror("Please enter Family AmEx Record Locator Number");
                isValid = false;
            }
        } 
        return isValid
    }
    // console.log("DOBErr",DOBErr);
    const handleSubmit = () => {
        setDisableBtn(true);


        if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
            (userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            let value = participant && participant.userID;
            if (value === undefined || value === null || value === 0) {
                setPartiErrorState(true);
                setParticipantNameErr('Please Select Participant');
                setDisableBtn(false);
                return false;
            }
        }
        if (!isValidForm()) {
            setDisableBtn(false)
        } else {
            setDisableBtn(true);
            const flightinfoData = {
                FlightInfoID: flightinfoId > 0 ? flightinfoId : 0,
                EventID: eventInfo.eventID,
                UserID: participant && participant ? participant.userID : userInfo.userID,
                PlayerAmExLocatorNo: state.flightoneAmExrecLocatornum.get(),
                FamilyMemberName: state.familyMemberName.get(),
                FamilyMemberDOB: state.familyMemberDOB.get() && state.familyMemberDOB.get() ? dayjs(state.familyMemberDOB.get()).format('YYYY-MM-DDTHH:mm') : "",
                FamilyMemebrContactNo: state.familyMemberPhone.get(),
                IsfamilyMemberAttend: state.isfamilyMemberAttend.get(),
                Relation: state.familyMemberRelation.get(),
                FamilyAmExLocatorNo: state.familyMemberAmExlocatornumber.get(),
                CreatedBy: Helper.getStorage('userInfo').userID,
            };
            // console.log("flightinfoData",flightinfoData);
            ApiHelper.post(
                APIURLConstants.POST_COMBINEFLIGHTINFO,
                flightinfoData
            )
                .then(async (res) => {
                    if (res.data) {
                        if (params.flightinfoID > 0) {
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: true,
                                variant: 'success',
                                message: 'Request updated successfully',
                            });
                        } else {
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: true,
                                variant: 'success',
                                message: 'Request created successfully',
                            });
                        }
                        await updateModuleState();
                        setTimeout(() => {
                            let path = "";
                            if (!(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo))) {
                                path = generatePath(RouteConstants.COMBINE_FLIGHT_INFO, {
                                    eventID: eventInfo.eventID
                                });
                            } else {
                                path = generatePath(RouteConstants.COMBINE_FLIGHT_INFOLIST, {
                                    eventID: eventInfo.eventID
                                });
                            }
                            history.push({
                                pathname: path
                            });
                            setDisableBtn(true);
                            loading.set(false);
                        }, 100);

                    }
                })
                .catch((error) => {
                    loading.set(false);
                    console.log('Error : ', error);
                });
        }
    };
    const handleBtnCancel = () => {
        let path = ''
        if (!(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo))) {
            path = generatePath(RouteConstants.COMBINE_FLIGHT_INFO, {
                eventID: eventInfo.eventID
            });
        } else {
            path = generatePath(RouteConstants.COMBINE_FLIGHT_INFOLIST, {
                eventID: eventInfo.eventID
            });
        }
        history.push({
            pathname: path
        });
    };

    const handleflightAmExRecordChange = (event) => {
        const input = event.target.value;
        // const isValidInput = /^\d*$/.test(input);
        var isValidInput = new RegExp(/^[a-zA-Z0-9 ]*$/);
        state.flightoneAmExrecLocatornum.set(input);
        handleDisableBtn();
        if (isValidInput.test(input)) {
            state.flightoneAmExrecLocatornum.set(input);
            setarmxerror('');
            return true;
        } else if (input === '') {
            setarmxerror('Please enter AmEx Record Locator Number');
            return false;
        } else {
            setarmxerror('Please enter only numbers for AmEx Record Locator Number');
            return false;
        }

    };

    const handlefamilyAmExRecordChange = (value) => {
        const input = value;
        var isValidInput = new RegExp(/^[a-zA-Z0-9 ]*$/);
        handleDisableBtn();
        state.familyMemberAmExlocatornumber.set(input);
        if (input === '') {
            setFamarmxerror('Please enter AmEx Record Locator Number');
            return false;
        } else if (!isValidInput.test(input)) {
            setFamarmxerror('Please enter only numbers for AmEx Record Locator Number');
            return false;
        } else {
            setFamarmxerror('');
            return true;
        }
    };

    return (
        <>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : modPermission && modPermission != FULL_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <Box
                    className="contentBox"
                    style={{ paddingLeft: '24px', paddingRight: '24px' }}>
                    <Box
                        sx={{
                            backgroundColor: '#fff',
                        }}>
                        <Box
                            sx={{
                                width: '100%',
                            }}>
                            <Box>
                                <Title title="Flight Info" />
                            </Box>
                            {showDetails && (
                                <DetailsComponent data={showDetailData} />
                            )}
                            {isParticipant && (
                                <Box
                                    sx={{
                                        width: ' 30%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 0.3,
                                        justifyContent: 'center',
                                        mx: 'auto',
                                    }}>
                                    <ParticipantAutoList
                                        // disableParticipant={
                                        //     participant
                                        //         ? true
                                        //         : false
                                        // }
                                        participant={participant}
                                        setParticipant={changeParticipant}
                                        participantList={participantList}
                                        modPermission={
                                            modPermission
                                                ? modPermission
                                                : FULL_PERMISSION
                                        }
                                        error={partiErrorState}
                                        errorText={participantNameErr}
                                    />
                                </Box>
                            )}
                            <Box
                                className="contentBox"
                                sx={{
                                    marginTop: 2,
                                    pb: 2,
                                    // p: 2,
                                    '& .MuiGrid-item': { p: '8px' },
                                    width: '100%',
                                }}>
                                <Grid
                                    alignItems="center"
                                    container
                                // rowSpacing={1}
                                // columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        md={12}
                                        lg={12}
                                        sx={{
                                            backgroundColor: '#D3D3D3',
                                        }}>
                                        <Typography
                                            sx={{ textAlign: 'left' }}
                                            fontWeight={600}>
                                            Flight One - PLAYER
                                        </Typography>
                                    </Grid>
                                    <Grid item lg={6} md={6} xs={12}>
                                        <InputLabel
                                            sx={{ textAlign: 'center' }}>
                                            AmEx Record Locator Number *:
                                        </InputLabel>
                                    </Grid>
                                    <Grid item lg={6} md={6} xs={12}>
                                        <TextField
                                            size="small"
                                            fullWidth
                                            id="outlined-basic"
                                            variant="outlined"
                                            value={state.flightoneAmExrecLocatornum.get()}
                                            onChange={
                                                handleflightAmExRecordChange
                                            }
                                            required={true}
                                            helperText={armxerror}
                                            error={
                                                armxerror.length > 0
                                                    ? true
                                                    : false
                                            }
                                        // disabled={checkEditPermission}
                                        />
                                    </Grid>
                                </Grid>
                                {
                                    showFamilySection &&
                                    <Grid
                                        alignItems="center"
                                        container
                                        // rowSpacing={1}
                                        // columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                                        sx={{
                                            marginTop: 1,
                                            pb: 2,
                                        }}>
                                        <Grid
                                            alignItems="center"
                                            container
                                            sx={{ backgroundColor: '#D3D3D3' }}>
                                            <Grid item lg={6} md={6} xs={12}>
                                                <Typography fontWeight={600}>
                                                    Flight Two - FAMILY MEMBER
                                                </Typography>
                                            </Grid>
                                            <Grid item lg={6} md={6} xs={12}>
                                                <FormGroup
                                                    sx={{
                                                        alignContent: 'flex-start',
                                                    }}>
                                                    <FormControlLabel
                                                        labelPlacement="start"
                                                        control={
                                                            <Switch
                                                                // disabled={
                                                                //     checkEditPermission
                                                                // }
                                                                checked={state.isfamilyMemberAttend.get()}
                                                                onChange={(e) =>
                                                                    onChangefamilyMemberAttend(
                                                                        e
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        label="I do not have a family member using the second flight"
                                                    />
                                                </FormGroup>
                                            </Grid>
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={12}>
                                            <InputLabel
                                                sx={{ textAlign: 'center' }}>
                                                Name {state.isfamilyMemberAttend.get() ? "" : '*'}:
                                            </InputLabel>
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={12}>
                                            <TextField
                                                error={
                                                    NameErr.length > 0
                                                        ? true
                                                        : false
                                                }
                                                helperText={
                                                    NameErr.length > 0
                                                        ? NameErr
                                                        : ''
                                                }
                                                fullWidth
                                                required={
                                                    state.isfamilyMemberAttend.get()
                                                        ? false
                                                        : true
                                                }
                                                size="small"
                                                id="outlined-basic"
                                                variant="outlined"
                                                onChange={(e) => {
                                                    state.familyMemberName.set(
                                                        e.target.value
                                                    );
                                                    state.familyMemberName.get()
                                                        ? null
                                                        : validateName();
                                                    setNameErr('')
                                                    handleDisableBtn();
                                                }}
                                                disabled={state.isfamilyMemberAttend.get()
                                                    ? true
                                                    : false}
                                                inputProps={{ maxLength: 255 }}
                                                value={
                                                    state.familyMemberName.get() &&
                                                    state.familyMemberName.get()
                                                }
                                                onBlur={() => {
                                                    params.flightinfoID > 0 ||
                                                        state.isfamilyMemberAttend.get()
                                                        ? null
                                                        : validateName();
                                                }}
                                            />
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={12}>
                                            <InputLabel
                                                sx={{ textAlign: 'center' }}>
                                                Date of Birth {state.isfamilyMemberAttend.get() ? "" : '*'} :
                                            </InputLabel>
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={12}>
                                            <MUIDatePicker
                                                error={
                                                    DOBErr
                                                }
                                                value={state.familyMemberDOB.get()}
                                                setValue={(newValue) => {
                                                    if (newValue) {
                                                        state.familyMemberDOB.set(
                                                            dayjs(newValue).format('YYYY-MM-DDTHH:mm')
                                                        );
                                                        setDOBerr('')
                                                        handleDisableBtn();
                                                    }
                                                }}
                                                disabled={state.isfamilyMemberAttend.get()
                                                    ? true
                                                    : false}
                                                disableFuture={true}
                                            />
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={12}>
                                            <InputLabel
                                                sx={{ textAlign: 'center' }}>
                                                Phone Number {state.isfamilyMemberAttend.get() ? "" : '*'} :
                                            </InputLabel>
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={12}>
                                            <PhoneNumber
                                                value={state.familyMemberPhone.get()}
                                                onChange={(val) => {
                                                    state.familyMemberPhone.set(
                                                        val
                                                    );
                                                    setPhoneError('')
                                                    handleDisableBtn();
                                                }}
                                                required={
                                                    state.isfamilyMemberAttend.get()
                                                        ? false
                                                        : true
                                                }
                                                helperText={phoneerr}
                                                error={
                                                    phoneerr.length > 0
                                                        ? true
                                                        : false
                                                }
                                                disabled={state.isfamilyMemberAttend.get()
                                                    ? true
                                                    : false}
                                                label={''}
                                            />
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={12}>
                                            <InputLabel
                                                sx={{ textAlign: 'center' }}>
                                                Relation {state.isfamilyMemberAttend.get() ? "" : '*'} :
                                            </InputLabel>
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={12}>
                                            <TextField
                                                error={
                                                    relationerr.length > 0
                                                        ? true
                                                        : false
                                                }
                                                helperText={
                                                    relationerr.length > 0
                                                        ? relationerr
                                                        : ''
                                                }
                                                required={
                                                    state.isfamilyMemberAttend.get()
                                                        ? false
                                                        : true
                                                }
                                                size="small"
                                                fullWidth
                                                id="outlined-basic"
                                                variant="outlined"
                                                onChange={(e) => {
                                                    state.familyMemberRelation.set(
                                                        e.target.value
                                                    );
                                                    state.familyMemberRelation.get()
                                                        ? null
                                                        : validateRelation();
                                                    setRelationerr('')
                                                    handleDisableBtn();
                                                }}
                                                disabled={state.isfamilyMemberAttend.get()
                                                    ? true
                                                    : false}
                                                inputProps={{ maxLength: 255 }}
                                                value={state.familyMemberRelation.get()}
                                                onBlur={() => {
                                                    params.flightinfoID > 0 ||
                                                        state.isfamilyMemberAttend.get()
                                                        ? null
                                                        : validateRelation();
                                                }}
                                            />
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={12}>
                                            <InputLabel
                                                sx={{ textAlign: 'center' }}>
                                                AmEx Record Locator Number {state.isfamilyMemberAttend.get() ? "" : '*'} :
                                            </InputLabel>
                                        </Grid>
                                        <Grid item lg={6} md={6} xs={12}>
                                            <TextField
                                                size="small"
                                                fullWidth
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={state.familyMemberAmExlocatornumber.get()}
                                                onChange={(event) => {
                                                    handlefamilyAmExRecordChange(event.target.value)
                                                }}
                                                required={
                                                    state.isfamilyMemberAttend.get()
                                                        ? false
                                                        : true
                                                }
                                                helperText={famarmxerror}
                                                error={
                                                    famarmxerror.length > 0
                                                        ? true
                                                        : false
                                                }
                                                disabled={state.isfamilyMemberAttend.get()
                                                    ? true
                                                    : false}
                                            />
                                        </Grid>
                                    </Grid>
                                }

                                <Divider component="div" />
                                {(() => {
                                    const gUserInfo =
                                        Helper.getStorage('userInfo');
                                    if (
                                        Helper.isAdminUser(gUserInfo) ||
                                        (gUserInfo.roles &&
                                            Helper.isEventAdmin(gUserInfo))
                                    ) {
                                        return (
                                            <ButtonContainer
                                                handleCancel={handleBtnCancel}
                                                handleClick={handleSubmit}
                                                buttonText={
                                                    flightinfoId > 0
                                                        ? 'Update'
                                                        : 'Create'
                                                }
                                                disableUpdateButton={eventInfo.readonlyOrHide === 1 ? true : disableBtn}
                                            // disableButton={ eventInfo.readonlyOrHide === 1 ? true  : disableBtn : false  }
                                            />
                                        );
                                    } else {
                                        return (
                                            <ButtonContainer
                                                handleCancel={handleBtnCancel}
                                                handleClick={handleSubmit}
                                                buttonText={
                                                    flightinfoId > 0
                                                        ? 'Update'
                                                        : 'Submit'
                                                }
                                                disableButton={
                                                    eventInfo.readonlyOrHide ===
                                                        1
                                                        ? eventRole !==
                                                            AppConstants
                                                                .EVENT_ROLES[0]
                                                            ? userInfo.userType !==
                                                                AppConstants
                                                                    .USER_TYPES[0]
                                                                ? true
                                                                : !checkEditPermission
                                                                    ? true
                                                                    : false
                                                            : false
                                                        : false
                                                }
                                                // hideCancel={true}
                                                disableUpdateButton={
                                                    eventInfo.readonlyOrHide ===
                                                        1
                                                        ? true
                                                        : params !== undefined
                                                            ? disableBtn
                                                            : false
                                                }
                                                style={{
                                                    width: '50px !important',
                                                }}
                                            />
                                        );
                                    }
                                })()}
                            </Box>
                        </Box>
                    </Box>
                    {snackBarProps.openSnack && (
                        <CustomizedSnackbars
                            {...snackBarProps}
                            onClose={() =>
                                setSnackBarProps({ ...snackBarProps, openSnack: false })
                            }></CustomizedSnackbars>
                    )}
                </Box>
            )}
            {/* </Grid> */}
        </>
    );
};

export default {
    routeProps: {
        path: [RouteConstants.COMBINE_CREATE_FLIGHTINFO, RouteConstants.COMBINE_EDIT_FLIGHTINFO],
        component: Createflightinfo,
    },
    name: 'Createflightinfo',
};
